import React from 'react';
import styled from 'styled-components';
import { numeralify } from 'common/utils/utils';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

const ColorfulDot = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50px;
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${backgroundColor}` : ''};
  margin-bottom: 0.7rem;
`;

const WorkBreakdownCell = ({ title, value, color }) => (
  <Flex direction='column'>
    <ColorfulDot backgroundColor={color} />
    <div>
      <Text size='large' color='black'>
        {numeralify(value)}
      </Text>
    </div>
    <div>
      <Text size='medium' color='shuttleGray'>
        {title}
      </Text>
    </div>
  </Flex>
);

export default WorkBreakdownCell;
